import { render } from "./MergeFields.vue?vue&type=template&id=468a2990"
import script from "./MergeFields.vue?vue&type=script&lang=js"
export * from "./MergeFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__